import * as $rdf from '@rdf-esm/data-model';
export function exactId(response) {
  return $rdf.namedNode(response.resourceUri);
}